import { z } from "zod";

export const serverResponse = z.array(
  z.object({
    streetId: z.number(),
    street: z.string(),
  }),
);
